<template>
  <div class="container-fluid">
    <h3>Kunden - CRM Historie</h3>
    <b-table class="mt-3" striped hover :fields="fields" :items="rows">
    </b-table>
  </div>
</template>

<script>
import customers from '@/modules/customers.js'

export default {
  name: 'CRMHistoryList',
  props: ['customer'],
  data() {
    return {
      fields: [
        {label:"ID",          key:"id"},
        {label:"Datum",         key:"editDate"},
        {label:"Mitarbeiter",   key:"lastEditor"},
        {label:"Text",        key:"text"}
      ],
      rows: []
    }
  },
  mounted: function() {
    var self = this;
    customers.listcrmentries(this,this.customer,0,40, function(data) {
      self.rows = data;
    });
  }
}
</script>
